export function convertBrl(value) {
  const valueType = Number(value);

  return valueType.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });
}

export function convertToFloat(value) {
  if (typeof value === 'number') {
    return value;
  }
  if (value.includes('R$')) {
    return convertToFloatBr(value);
  }
  return parseFloat(value.replace(/[^\d.,]/g, '').replace(',', '.'));
}

export function convertToFloatBr(value) {
  if (typeof value === 'number') {
    return value;
  }
  let data = value
    .replace('R$ ', '')
    .replace('.', '')
    .replace(',', '.')
    .replace(/[^\d.-]/g, '')
    .replace(/(\..*)\./g, '$1')
    .replace(/^(\d*\.\d*)\./g, '$1');
  return parseFloat(data);
}

export const showDateFormated = (dateString) => {
  const date = new Date(dateString);

  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  };
  return date.toLocaleDateString('pt-BR', options);
};

export function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}
